import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";
import { useForm } from "react-hook-form";
import Dialog from "../../../waybee-ui/Dialog";
import Button from "../../../waybee-ui/Button";

const ContentGrid = styled(Grid)`
  padding: 45px 65px 60px 65px;
`;

const Label = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
  margin-top: 15px;
`;

const CategoriesDialog = ({ open, onClose, onSave, values }) => {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: "",
      description: ""
    }
  });

  useEffect(() => {
    if (open) {
      if (values) {
        reset(values);
      } else {
        reset({
          name: "",
          description: ""
        });
      }
    }
  }, [open, reset, values]);

  const onSaveCategory = data => {
    onSave(data);
  };

  return (
    <Dialog open={open} onClose={onClose} closeButton maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit(onSaveCategory)}>
        <ContentGrid container spacing={2}>
          <Grid item xs={12}>
            <Label>Nome da Categoria</Label>
            <TextField
              {...register("name", { required: "Campo obrigatório" })}
              variant="outlined"
              fullWidth
              error={!!errors.name}
              helperText={errors.name?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Label>Descrição</Label>
            <TextField
              {...register("description", { required: "Campo obrigatório" })}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              error={!!errors.description}
              helperText={errors.description?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="secondary">
              Salvar
            </Button>
          </Grid>
        </ContentGrid>
      </form>
    </Dialog>
  );
};

CategoriesDialog.defaultProps = {
  values: null
};

CategoriesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  values: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string
  })
};

export default CategoriesDialog;
